/* Swiper replacements for former Slick sliders. Vanilla JS, no jQuery. */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function whenSwiper(fn, tries) {
    tries = tries || 0;
    if (typeof window.Swiper !== 'undefined') { fn(); return; }
    if (tries > 120) return;
    setTimeout(function () { whenSwiper(fn, tries + 1); }, 50);
  }
  function initEach(selector, buildOpts) {
    document.querySelectorAll(selector).forEach(function (el) {
      if (el.dataset.swiperReady) return;
      el.dataset.swiperReady = '1';
      new window.Swiper(el, buildOpts(el));
    });
  }
  function nav(el) {
    return { nextEl: el.querySelector('.swiper-button-next'), prevEl: el.querySelector('.swiper-button-prev') };
  }

  /* Slick used lazyLoad for these images; without Slick they must be promoted to real src. */
  function promoteLazyImages(root) {
    root.querySelectorAll('img[data-lazy], img[data-src]').forEach(function (img) {
      var u = img.getAttribute('data-lazy') || img.getAttribute('data-src');
      if (u && (!img.getAttribute('src') || img.getAttribute('src').indexOf('data:') === 0)) img.setAttribute('src', u);
      var dt = img.getAttribute('dt');
      if (dt && !img.getAttribute('srcset')) img.setAttribute('srcset', dt);
    });
  }
  /* Slick made direct children slides; Swiper needs .swiper-wrapper > .swiper-slide. */
  function wrapSlides(el) {
    if (el.querySelector(':scope > .swiper-wrapper')) return true;
    var wrap = document.createElement('div');
    wrap.className = 'swiper-wrapper';
    Array.prototype.slice.call(el.children).forEach(function (k) {
      if (k.nodeType === 1) k.classList.add('swiper-slide');
      wrap.appendChild(k);
    });
    el.appendChild(wrap);
    el.classList.add('swiper');
    return true;
  }
  /* Wrap direct children + init Swiper. Returns the Swiper instance (or null). */
  function initWrapped(selector, buildOpts) {
    var made = [];
    document.querySelectorAll(selector).forEach(function (el) {
      if (el.dataset.swiperReady) return;
      promoteLazyImages(el);
      wrapSlides(el);
      el.dataset.swiperReady = '1';
      made.push(new window.Swiper(el, buildOpts(el)));
    });
    return made;
  }
  function initFeatured() {
    document.querySelectorAll('.featured-collection-carousel, .featured-collection-carousel-membership').forEach(function (el) {
      if (el.dataset.swiperReady) return;
      el.dataset.swiperReady = '1';
      promoteLazyImages(el);
      wrapSlides(el);
      var n = parseInt(el.dataset.productsPerSlide, 10) || 3;
      var nm = Math.min(parseInt(el.dataset.productsPerSlideMobile, 10) || 1, n) || 1;
      new window.Swiper(el, {
        slidesPerView: nm, spaceBetween: 16, watchOverflow: true, loop: true,
        breakpoints: { 768: { slidesPerView: n } }
      });
    });
  }
  /* Wrap only the matching direct children (leave arrows/dots as siblings). */
  function wrapMatching(el, slideSel) {
    if (el.querySelector(':scope > .swiper-wrapper')) return true;
    var slides = el.querySelectorAll(':scope > ' + slideSel);
    if (!slides.length) return false;
    var wrap = document.createElement('div');
    wrap.className = 'swiper-wrapper';
    slides.forEach(function (s) { s.classList.add('swiper-slide'); wrap.appendChild(s); });
    el.insertBefore(wrap, el.firstChild);
    el.classList.add('swiper');
    return true;
  }
  /* byob-3 PDP gallery: main image slider + thumbnail nav (was Slick asNavFor). */
  function initGalleries() {
    document.querySelectorAll('.product-gallery--slider').forEach(function (main) {
      if (main.dataset.swiperReady) return;
      promoteLazyImages(main);
      if (!wrapMatching(main, '.product-gallery--viewport--figure')) return;
      main.dataset.swiperReady = '1';
      var id = main.getAttribute('data-product-id');
      var navEl = id ? document.querySelector('.product-gallery--nav-slider-' + id) : null;
      var thumbs = null;
      if (navEl && wrapMatching(navEl, '.thumb_inner')) {
        promoteLazyImages(navEl);
        thumbs = new window.Swiper(navEl, { slidesPerView: 5, spaceBetween: 8, watchSlidesProgress: true, freeMode: true });
      }
      new window.Swiper(main, {
        slidesPerView: 1, watchOverflow: true,
        navigation: { prevEl: main.querySelector('.pdp-prev-arrow'), nextEl: main.querySelector('.pdp-next-arrow') },
        pagination: { el: main.querySelector('.pdp-slider-dots'), clickable: true },
        thumbs: thumbs ? { swiper: thumbs } : undefined
      });
    });
  }
  window.__sliders = { ready: ready, whenSwiper: whenSwiper, initEach: initEach, nav: nav, initFeatured: initFeatured, initGalleries: initGalleries };

  ready(function () {
    whenSwiper(function () {
      /* review-row + leftreview-wrap: single slide, arrows, loop */
      initEach('.review-row.swiper, .leftreview-wrap.swiper', function (el) {
        return { slidesPerView: 1, loop: true, speed: 1500, navigation: nav(el) };
      });

      /* review_slider: 3->2->1, external .prev/.next arrows in .review_inner */
      initEach('.review_slider.swiper', function (el) {
        var scope = el.closest('.review_inner') || document;
        return {
          slidesPerView: 1, spaceBetween: 20,
          navigation: { prevEl: scope.querySelector('.prev'), nextEl: scope.querySelector('.next') },
          breakpoints: { 768: { slidesPerView: 2 }, 1141: { slidesPerView: 3 } }
        };
      });

      /* featured-collection recommendation carousels (×7 sections) */
      initFeatured();

      /* byob-3 PDP galleries (main + thumbnail nav) */
      initGalleries();

      /* extra Slick sliders (were in custom.js / sections / cart-mini) */
      initWrapped('.marquee-slider-wrapper', function () {
        return { slidesPerView: 'auto', loop: true, allowTouchMove: false, speed: 4000, autoplay: { delay: 0, disableOnInteraction: false } };
      });
      initWrapped('#shopify-section-static-gift-collection-v2 .product-list', function (el) {
        return { slidesPerView: 1, spaceBetween: 16, loop: true, navigation: nav(el), breakpoints: { 768: { slidesPerView: 3 } } };
      });
      initWrapped('.membership-product-slider', function (el) {
        return { slidesPerView: 1, spaceBetween: 16, navigation: nav(el), breakpoints: { 768: { slidesPerView: 2 }, 992: { slidesPerView: 3 } } };
      });
      var msn = initWrapped('.mobile-shop-by-solution-nav-swiper ul', function () {
        return { slidesPerView: 3, centeredSlides: true, initialSlide: 1, watchOverflow: true };
      });
      if (msn && msn[0]) window.__mobileSolutionSwiper = msn[0];
      if (window.innerWidth < 1000) {
        initWrapped('.perks-slider-perks', function (el) { return { slidesPerView: 1, navigation: nav(el), watchOverflow: true }; });
      }
    });
  });

  /* theme editor: re-init carousels when a section reloads */
  document.addEventListener('shopify:section:load', function () {
    whenSwiper(function () { initFeatured(); initGalleries(); });
  });
})();
